import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, useTheme } from 'styled-components';
import { Media } from '../../../theme/Media.js';
import Icons from '../../Elements/Icons/index.js';
import Typography from '../../Typography/index.js';
export const getColorByType = (theme, type) => {
    let color;
    switch (type) {
        case 'success':
            color = theme.colors.positive120;
            break;
        case 'error':
            color = theme.colors.critical120;
            break;
        case 'warning':
            color = theme.colors.warning120;
            break;
        default:
            color = theme.colors.link120;
    }
    return color;
};
const CloseIconWrapper = styled.div `
  border-radius: 999px;
  background-color: ${({ theme }) => theme.colors.grey00_1};
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: auto;
`;
const CloseIconOuterWrapper = styled.div `
  padding-left: 16px;
`;
export const CloseButton = ({ closeToast }) => {
    const theme = useTheme();
    return (_jsx(CloseIconOuterWrapper, { children: _jsx(CloseIconWrapper, { onClick: closeToast, children: _jsx(Icons.Close, { size: 14, color: theme.colors.black_1 }) }) }));
};
const IconWrapper = styled.div `
  flex-basis: 20px;
  height: 20px;
`;
export const InfoIcon = ({ type }) => {
    const theme = useTheme();
    const color = getColorByType(theme, type);
    return (_jsxs(IconWrapper, { children: [type === 'warning' && _jsx(Icons.Warning, { filled: true, size: 20, color: color }), type === 'error' && _jsx(Icons.Clear, { filled: true, size: 20, color: color }), type !== 'warning' && type !== 'error' && _jsx(Icons.Info, { filled: true, size: 20, color: color })] }));
};
const Wrapper = styled.div `
  flex: auto;
`;
const TextMedium = styled(Typography.TextMedium) `
  ${({ $maxHeight }) => $maxHeight &&
    `
      ${`@media ${Media.mlMax}`} {
    max-height: ${$maxHeight}px;
    overflow-y: auto;
  `}
`;
export const Message = ({ title, body, type, maxHeight }) => {
    const theme = useTheme();
    return (_jsxs(Wrapper, { "data-testid": 'notification-message', children: [title && (_jsx(Typography.TextLarge, { color: getColorByType(theme, type), children: _jsx("b", { "data-testid": 'title', children: title }) })), _jsx(TextMedium, { as: 'div', color: getColorByType(theme, type), "data-testid": 'body', $maxHeight: maxHeight, children: title ? body : _jsx("b", { "data-testid": 'body', children: body }) })] }));
};
